// The model appends a `<!-- quick_actions: [...] -->` metadata comment to its
// final answer so the client can render action chips. That comment must never
// be shown to the user — strip it before rendering the message content.
export function stripQuickActionsComment(text: string): string {
  return text
    .replace(new RegExp('<!--\\s*quick_actions:\\s*\\[.*?\\]\\s*-->', 'gs'), '')
    .trim();
}
